import * as React from "react";
import { useAlgoliaSearch } from "../../../../../hooks/Algolia/hooks/use-algolia-search.js";
import { createFiltersFromSkus, createFiltersFromQuery } from "./utils.js";
function QueryAlgoliaProducts({
  skus,
  queryString,
  ruleContext,
  algoliaConfig,
  children
}) {
  const searchOptions = React.useMemo(() => {
    const ruleContexts = typeof ruleContext === "string" ? [ruleContext] : ruleContext;
    const filters = skus.length > 0 ? createFiltersFromSkus(skus) : createFiltersFromQuery(queryString, algoliaConfig.facets);
    return {
      filters,
      ruleContexts
    };
  }, [skus, ruleContext, queryString, algoliaConfig]);
  const result = useAlgoliaSearch(algoliaConfig, searchOptions);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children({ ...result, result: result.result }));
}
export {
  QueryAlgoliaProducts
};
//# sourceMappingURL=QueryAlgoliaProducts.js.map
